import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f3a37ca0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f3a37ca0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a37ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3a37ca0')) {
      api.createRecord('f3a37ca0', component.options)
    } else {
      api.reload('f3a37ca0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f3a37ca0&scoped=true", function () {
      api.rerender('f3a37ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/code-editor/index.vue"
export default component.exports